<template>
  <Modal title="用户信息" width="1080" :value="value" :mask-closable="false" @on-visible-change="onVisibleChange">
    <div class="toolbar">
      <Input v-model.trim="query.keyword" clearable placeholder="名称或登录账号" @on-enter="search" />
      <Select v-model="query.userType" clearable placeholder="全部类型" class="type-select">
        <Option value="INTERNAL">内部用户</Option>
        <Option value="SUPPLIER">供应商客户</Option>
      </Select>
      <Button type="primary" icon="ios-search" @click="search">查询</Button>
      <Button icon="md-add" @click="openAdd">新增</Button>
    </div>

    <CTable :columns="columns" :data="list" :total="total" :current="query.page" :page-size="query.pageSize" :show-page="true" @change="changePage" />

    <Modal :title="editData.id ? '编辑用户' : '新增用户'" width="620" :value="editModal" :mask-closable="false" @on-visible-change="onEditVisibleChange">
      <Form ref="editForm" :model="editData" :rules="editRules" :label-width="100">
        <FormItem label="用户类型" prop="userType">
          <Select v-model="editData.userType" :disabled="Boolean(editData.id)">
            <Option value="INTERNAL">内部用户</Option>
            <Option value="SUPPLIER">供应商客户</Option>
          </Select>
        </FormItem>
        <FormItem label="用户名称" prop="userName"><Input v-model.trim="editData.userName" placeholder="请输入用户名称" /></FormItem>
        <FormItem label="登录账号" prop="userAccount"><Input v-model.trim="editData.userAccount" :disabled="internalLoginAccountLocked" placeholder="请输入登录账号" /></FormItem>
        <FormItem label="登录密码" prop="userPwd"><Input type="password" v-model="editData.userPwd" :placeholder="editData.id ? '留空保持不变' : '请输入登录密码'" /></FormItem>
      </Form>
      <div slot="footer"><Button @click="editModal = false">取消</Button><Button type="primary" :loading="saving" @click="saveUser">保存</Button></div>
    </Modal>

    <Modal title="修改密码" width="420" :value="passwordModal" :mask-closable="false" @on-visible-change="onPasswordVisibleChange">
      <Form ref="passwordForm" :model="passwordData" :rules="passwordRules" :label-width="90">
        <FormItem label="新密码" prop="pwd"><Input type="password" v-model="passwordData.pwd" /></FormItem>
        <FormItem label="确认密码" prop="pwd2"><Input type="password" v-model="passwordData.pwd2" /></FormItem>
      </Form>
      <div slot="footer"><Button @click="passwordModal = false">取消</Button><Button type="primary" @click="savePassword">保存</Button></div>
    </Modal>
  </Modal>
</template>

<script>
import CTable from '@/components/CTable'

export default {
  name: 'UserInfoModal',
  components: {CTable},
  model: {prop: 'value', event: 'change'},
  props: {value: Boolean},
  data () {
    const required = message => ({required: true, message, trigger: 'blur'})
    return {
      list: [],
      total: 0,
      saving: false,
      editModal: false,
      passwordModal: false,
      passwordUser: null,
      query: {page: 1, pageSize: 10, keyword: '', userType: ''},
      editData: this.emptyUser(),
      passwordData: {pwd: '', pwd2: ''},
      editRules: {
        userType: [required('请选择用户类型')],
        userName: [required('请输入用户名称')],
        userAccount: [required('请输入登录账号')]
      },
      passwordRules: {pwd: [required('请输入新密码')], pwd2: [required('请确认密码')]},
      columns: [
        {title: '类型', key: 'userType', width: 150, render: (h, p) => h('span', p.row.userType === 'SUPPLIER' ? '供应商客户' : '内部用户')},
        {title: '用户名称', key: 'userName', minWidth: 200},
        {title: '登录账号', key: 'userCode', minWidth: 200},
        {title: '操作', key: 'action', width: 250, render: (h, p) => this.renderActions(h, p.row)}
      ]
    }
  },
  watch: {
    value (visible) {
      if (visible) this.loadData()
    }
  },
  computed: {
    internalLoginAccountLocked () {
      return Boolean(this.editData.id) && this.editData.userType === 'INTERNAL'
    }
  },
  methods: {
    emptyUser () {
      return {id: null, userType: 'INTERNAL', userName: '', userAccount: '', userPwd: '', roleCode: '', dptCode: '', areaCode: ''}
    },
    onVisibleChange (visible) {
      if (this.value !== visible) this.$emit('change', visible)
    },
    renderActions (h, row) {
      const isAdmin = row.userType === 'INTERNAL' && String(row.userAccount || '').toLowerCase() === 'admin'
      return h('div', [
        h('a', {on: {click: () => this.openEdit(row)}}, '编辑'),
        h('a', {style: {marginLeft: '12px'}, on: {click: () => this.openPassword(row)}}, '修改密码'),
        h('a', {style: {marginLeft: '12px', color: isAdmin ? '#c5c8ce' : '#ed4014', cursor: isAdmin ? 'not-allowed' : 'pointer'}, on: {click: () => { if (!isAdmin) this.deleteUser(row) }}}, '删除')
      ])
    },
    search () {
      this.query.page = 1
      this.loadData()
    },
    changePage (page) {
      const nextPage = Number(page)
      this.query.page = Number.isFinite(nextPage) && nextPage > 0 ? nextPage : 1
      this.loadData()
    },
    loadData () {
      this.$fetch('SysUser/getManageList', this.query).then(res => {
        this.list = (res.data && res.data.list) || []
        this.total = Number(res.data && res.data.total) || 0
      })
    },
    openAdd () {
      this.editData = this.emptyUser()
      this.editModal = true
    },
    openEdit (row) {
      // 编辑必须携带原表主键；缺少主键时禁止提交，避免后端误走新增分支。
      if (row.id === null || row.id === undefined) {
        this.$Message.error('用户主键缺失，无法编辑')
        return
      }
      this.editData = Object.assign(this.emptyUser(), row, {userPwd: ''})
      this.editModal = true
    },
    onEditVisibleChange (visible) {
      if (this.editModal !== visible) this.editModal = visible
      if (!visible && this.$refs.editForm) this.$refs.editForm.resetFields()
    },
    saveUser () {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        if (!this.editData.id && !String(this.editData.userPwd || '').trim()) {
          this.$Message.error('请输入登录密码')
          return
        }
        this.saving = true
        this.$fetch('SysUser/saveManage', this.editData, 'POST').then(() => {
          this.$Message.success('保存成功')
          this.editModal = false
          this.loadData()
        }, () => {}).then(() => { this.saving = false })
      })
    },
    openPassword (row) {
      this.passwordUser = row
      this.passwordData = {pwd: '', pwd2: ''}
      this.passwordModal = true
    },
    onPasswordVisibleChange (visible) {
      if (this.passwordModal !== visible) this.passwordModal = visible
    },
    savePassword () {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return
        if (this.passwordData.pwd !== this.passwordData.pwd2) {
          this.$Message.error('两次密码不一致')
          return
        }
        this.$fetch('SysUser/updateManagePwd', {userType: this.passwordUser.userType, id: this.passwordUser.id, userPwd: this.passwordData.pwd}).then(() => {
          this.$Message.success('密码修改成功')
          this.passwordModal = false
        })
      })
    },
    deleteUser (row) {
      this.$Modal.confirm({
        title: '删除用户',
        content: `<p>确认删除“${row.userName}”吗？</p>`,
        onOk: () => this.$fetch('SysUser/delManage', {userType: row.userType, id: row.id}).then(() => {
          this.$Message.success('删除成功')
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.toolbar .ivu-input-wrapper { width: 220px; }
.type-select { width: 150px; }
</style>
